const getCurrentPrice = require('../../product/tools/get-current-price')
const get = require('lodash/get')

const transformProducts = (products = [], warehouseByMarket = {}) => {
  return products
    .filter(product => product.additionalData.market && ['LGS', 'NBO'].includes(product.additionalData.market))
    .map(product => {
      const priceValue = getCurrentPrice(product.prices)
      const buyPriceValue = getCurrentPrice(product.buyPrices)
      if (priceValue == null || buyPriceValue == null) return

      const market = get(product, 'additionalData.market')
      const warehouseCode = get(warehouseByMarket[market], 'code')
      if (!warehouseCode) return

      return {
        ean: product.ean || '',
        hsn: product.hsn || '',
        code: product.code,
        price: Number(priceValue),
        deleted: false,
        buyPrice: Number(buyPriceValue),
        category: get(product, 'additionalData.category'),
        coldChain: product.coldChain || false,
        scannable: product.ean ? product.scannable : false,
        serialized: product.serialized || false,
        description: product.fullName,
        productType: product.productType,
        manufacturer: get(product, 'additionalData.manufacturer'),
        tracksBatches: product.tracksBatches || true,
        minimum_shelf_life: product.minimumShelfLife || 0,
        product_shelf_life: product.productShelfLife || 0,
        customer_shelf_life: product.customerShelfLife || 0,
        warehouseCode
      }
    })
    .filter(x => x)
}

const groupProductsByWarehouse = (products = [], batchSize = 100) => {
  if (!Array.isArray(products)) return []

  const byWarehouse = new Map()

  for (const product of products) {
    if (!product || !product.warehouseCode) continue
    if (!byWarehouse.has(product.warehouseCode)) {
      byWarehouse.set(product.warehouseCode, [])
    }
    byWarehouse.get(product.warehouseCode).push(product)
  }

  const batches = []
  for (const warehouseProducts of byWarehouse.values()) {
    for (let i = 0; i < warehouseProducts.length; i += batchSize) {
      batches.push(warehouseProducts.slice(i, i + batchSize))
    }
  }

  return batches
}

module.exports = { transformProducts, groupProductsByWarehouse }
